const SIZES = {
	GUTTER: '24px',
	COLUMN: '20px'
}

export default SIZES;
